export default "#### **Collection**\n\nCarma Collect {suburb_state}\n";